import * as React from 'react';
import { Misc } from '@singularsystems/neo-core';
import { NeoReactTypes } from '../Modules/Types';
var InputHelpers = /** @class */ (function () {
    function InputHelpers() {
    }
    InputHelpers.surroundWithInputGroup = function (element, props, inputRef) {
        if (!this.iconFactory) {
            this.iconFactory = Misc.Globals.appService.get(NeoReactTypes.Components.IconFactory);
        }
        if (props.requiresGroup) {
            return (React.createElement("div", { className: "input-group" },
                (props.prependText || props.prepend) &&
                    React.createElement("div", { className: "input-group-prepend" },
                        props.prepend && (props.prepend instanceof Function ? props.prepend() : props.prepend),
                        props.prependText && React.createElement("span", { className: "input-group-text", onClick: function () { var _a; return (_a = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _a === void 0 ? void 0 : _a.focus(); } }, this.iconFactory.textOrIcon(props.prependText))),
                element,
                (props.appendText || props.append) &&
                    React.createElement("div", { className: "input-group-append" },
                        props.append && (props.append instanceof Function ? props.append() : props.append),
                        props.appendText && React.createElement("span", { className: "input-group-text", onClick: function () { var _a; return (_a = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _a === void 0 ? void 0 : _a.focus(); } }, this.iconFactory.textOrIcon(props.appendText)))));
        }
        else {
            return element;
        }
    };
    return InputHelpers;
}());
export { InputHelpers };
